var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "login" },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.submit()
        }
      }
    },
    [
      !_vm.send
        ? _c("div", [
            _c("p", [
              _vm._v(
                "Vul hieronder uw e-mailadres in waarmee u uw account geregistreerd heeft."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "U ontvangt van ons een activatielink om een nieuw wachtwoord aan te maken."
              )
            ]),
            _vm._v(" "),
            _vm.error
              ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "form-group--error": _vm.$v.email.$error }
              },
              [
                _c("label", { staticClass: "form__label" }, [_vm._v("E-mail")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form__input",
                  attrs: { type: "email" },
                  domProps: { value: _vm.email },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                      function($event) {
                        return _vm.$v.email.$touch()
                      }
                    ]
                  }
                })
              ]
            ),
            _vm._v(" "),
            !_vm.$v.email.email
              ? _c("span", { staticClass: "form-group__message" }, [
                  _vm._v("Invalid e-mail")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$v.email.minLength
              ? _c("span", { staticClass: "form-group__message" }, [
                  _vm._v(
                    "E-mail must have at least " +
                      _vm._s(_vm.$v.email.$params.minLength.min) +
                      " letters."
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              staticClass: "button dub-button dub-button-space",
              attrs: { type: "submit", value: "Stuur mij de link" },
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            })
          ])
        : _c(
            "div",
            [
              _c("p", [
                _vm._v(
                  "Wij hebben u een e-mail gestuurd. Deze bevat de gegevens om uw wachtwoord te kunnen wijzigen."
                )
              ]),
              _vm._v(" "),
              _c("router-link", { attrs: { to: "/" } }, [
                _vm._v("\n            Naar inloggen\n        ")
              ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10a52436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a52436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ForgotPassword.vue
// module id = null
// module chunks = 